import {AfterViewInit, Component, OnDestroy, OnInit, Input, Output, EventEmitter} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Constant } from "../../constant";
import { EventManagerService } from "../../service/event-manager.service";
import { DialogService } from "../../service/dialog.service";
import { ViewImageComponent } from '../view-image/view-image';
import { AgentService } from "src/app/main/agent/agent.service";
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
  selector: 'documents',
  templateUrl: "./documents.html",
  styleUrls: [
  ]
})

export class DocumentsComponent implements OnInit  {
    @Input('profileId') profileId: any;
    @Input('isOldImage ') isOldImage : boolean = false;;
    @Input('documents') documents: any;
    @Input('viewCode') viewCode: any;
    photo: any;
    Constant = Constant;
    isExporting: boolean = false;
    constructor(
        private translate: TranslateService,
        public agentService: AgentService,
        private eventManagerService: EventManagerService,
        private dialog: DialogService
    ) {

    }
    ngOnInit() {
        this.photo = {};
    }
    showPhoto(document) {
        this.dialog.showModal(ViewImageComponent, 'view-image-modal', {photo: document});
    }
    exportIdCard() {
        if (!this.profileId) {
            return;
        }
        if (this.isExporting) {
            return;
        }
        const body = {
            investmentProfileChangeRequestId: this.profileId,
            isOldImage: this.isOldImage
        }
        this.isExporting = true;
        this.agentService.exportIdCard(body)
        .subscribe((res: any) => {
        this.isExporting = false;
        }, (err) => {
        this.isExporting = false;
        })
    }
}
